import React from "react";
import { connect } from 'react-redux';
import { change } from 'redux-form';
import i18n from 'i18n';

import MUIDataTable from "mui-datatables";
import lodash from 'lodash';

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import CustomToolbar from "components/CustomToolbar/CustomToolbar.jsx";
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx";
import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

import { tagConstants, swalConstants } from '../../constants';
import { tagAction } from 'actions'
import { plugins, crmValidator } from 'helpers';

import TableLoaderSpinner from 'components/Table/TableLoaderSpinner'
import FormTag from 'views/Tag/FormTag.jsx'
import FormTagImportMember from 'views/Tag/FormTagImportMember.jsx';
import Badge from "components/Badge/Badge.jsx";

import SWImportResult from './SWImportResult';

const style = {
    customCardContentClass: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    actionDiv: {
        display: "inline-flex"
    }
};

const CustomMTablestyles = {
    ...MTablestyles,
    overrides: {
        ...MTablestyles.overrides,
        MUIDataTableHeadCell: {
            fixedHeader: {
                "&:nth-child(1)": {
                    width: "50%"
                },
            }
        }
    }
}

const moduleName = 'tag';

const renderBadgeStatus = (status) => {
    let BadgeColor
    switch (status) {
        case "Active": BadgeColor = "success"; break;
        case "Expired": BadgeColor = "danger"; break;
        default: BadgeColor = "gray";
    }
    return (<Badge color={BadgeColor}>{status}</Badge>)
}

const pageStyle = { ...style, ...sweetAlertStyle };
const THEME = createMuiTheme(CustomMTablestyles);

class TableTagList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loaderSpiner: false,
            page: 0,
            rowsPerPage: 10,
            count: 100,
            data: [],
            reqParams: ""
        }
        this.delayedCallback = lodash.debounce(this.getData, 500)
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(tagAction.getTagList())
    }

    tableColumn() {
        const _this = this;
        const { classes, dispatch } = this.props;
        let columns = [
            { name: "_id", label: 'Id', options: { filter: false, display: "excluded" } },
            {
                name: "name", label: "Tag", options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const rowData = _this.getRowData(tableMeta.rowIndex)
                        return (
                            <Badge
                                color="primary"
                                title={rowData.name}
                                customStyle={{ backgroundColor: rowData.color, maxWidth: "100%" }}>
                                {rowData.name}
                            </Badge>
                        )
                    }
                }
            },
            {
                name: "startDate", label: "Start date", options: {
                    customBodyRender: (value) => {
                        return plugins.datetimeFormat(value, 'date')
                    }
                }
            },
            {
                name: "endDate", label: "End date", options: {
                    customBodyRender: (value) => {
                        return plugins.datetimeFormat(value, 'date')
                    }
                }
            },
            {
                name: "status", label: "Status", options: {
                    customBodyRender: (value) => {
                        return renderBadgeStatus(value)
                    }
                }
            }
        ]

        if (plugins.isHasPermission(moduleName, 'read')) {
            columns.push({
                label: "Action", options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowData = _this.getRowData(tableMeta.rowIndex)
                        return (
                            <div className={classes.actionDiv}>

                                {
                                    plugins.isHasPermission(moduleName, 'update') &&
                                    <TableActionButton
                                        actionType="edit"
                                        onClick={(e) => {
                                            this.openFormEdit(tableMeta.rowIndex)
                                        }}
                                    />
                                }
                                {plugins.isHasPermission(moduleName, 'delete') &&
                                    <TableActionButton
                                        actionType="delete"
                                        onClick={(e) => {
                                            dispatch({
                                                type: swalConstants.SHOW, data: {
                                                    type: "warning",
                                                    title: i18n.t("warning_messages.are_you_sure_delete_tag"),
                                                    message: `${rowData.name}`,
                                                    onConfirm: function () {
                                                        let reqParams = {
                                                            _id: rowData._id
                                                        }
                                                        dispatch({ type: swalConstants.HIDE })
                                                        dispatch(tagAction.deleteTag(reqParams));
                                                    },
                                                    onCancel: function () {
                                                        dispatch({ type: swalConstants.HIDE })
                                                    },
                                                    showCancel: true,
                                                    confirmBtnText: i18n.t("delete"),
                                                    cancelBtnText: i18n.t("cancel")
                                                }
                                            })
                                        }} />
                                }
                                {plugins.isHasPermission(moduleName, 'update') && (rowData.status === "Active" ?
                                    <TableActionButton
                                        actionType="tagImport"
                                        customBtnStyle={{ opacity: "0.8" }}
                                        onClick={(e) => {
                                            this.openFormImportMember(tableMeta.rowIndex)
                                        }} />
                                    :
                                    <TableActionButton
                                        actionType="tagImport"
                                        customBtnStyle={{ opacity: "0.3" }}
                                    />)
                                }
                            </div>
                        )
                    }
                }
            })
        }
        return columns
    }

    tableOptions() {
        const { tableDatas } = this.props;
        const _this = this
        let options = {
            serverSide: true,
            count: tableDatas.total,
            page: _this.state.page,
            rowsPerPage: _this.state.rowsPerPage,
            selectableRows: "none",
            print: false,
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [5, 10, 20],
            onTableChange: (action, tableState) => {
                let skip, limit, sortBy, sortDir, keyword = ""

                if (tableState.page !== null) {
                    skip = tableState.page
                }

                if (tableState.rowsPerPage !== null) {
                    limit = tableState.rowsPerPage
                }

                if (tableState.activeColumn !== null) {
                    sortBy = tableState.columns[tableState.activeColumn].name
                }
                if (tableState.announceText !== null) {
                    sortDir = tableState.announceText.search("descending") !== -1 ? "desc" : "asc"
                }
                if (tableState.searchText !== null || action === 'search') {
                    keyword = tableState.searchText
                    this.delayedCallback(skip, limit, sortBy, sortDir, keyword)
                }
                let actionList = ['changePage', 'sort', 'changeRowsPerPage']
                if (actionList.indexOf(action) !== -1) {
                    _this.getData(skip, limit, sortBy, sortDir, keyword)
                }

            }
        }

        if (plugins.isHasPermission(moduleName, 'create')) {
            options.customToolbar = () => {
                return (
                    <CustomToolbar handleClick={this.openFromAdd.bind(this)} title={i18n.t("label.add_new")} />
                );
            }
        }
        return options
    }

    getData = (skip, limit, sortBy, sortDir, keyword) => {
        const { dispatch, tableReload } = this.props

        let reqParams = "";

        if (!tableReload) {
            if (crmValidator.isEmptyValue(skip)) {
                skip = 0
            }

            if (crmValidator.isEmptyValue(limit)) {
                limit = 10
            }

            this.setState({
                page: skip,
                rowsPerPage: limit
            })
            skip = parseInt(limit) * parseInt(skip)

            reqParams += '&skip=' + skip
            reqParams += '&limit=' + limit

            if (!crmValidator.isEmptyValue(sortBy)) {
                reqParams += '&sortBy=' + sortBy
            }

            if (!crmValidator.isEmptyValue(sortDir)) {
                reqParams += '&sortDir=' + sortDir
            }

            if (!crmValidator.isEmptyValue(keyword)) {
                reqParams += '&keyword=' + encodeURIComponent(keyword)
            }
        } else {
            reqParams = this.state.reqParams
        }

        dispatch(tagAction.getTagList(reqParams));

        this.setState({
            reqParams: reqParams
        });

    }

    getRowData(rowIndex = 0) {
        const { tableDatas } = this.props;
        const data = tableDatas.tags;
        if (lodash.size(data) > 0) {
            return data[rowIndex];
        } else {
            return null
        }
    }

    openFromAdd() {
        const { dispatch } = this.props;
        dispatch({
            type: tagConstants.OPEN_ADD, formInitialValue: {
                status: 'Active'
            }
        })
    }

    openFormEdit(rowIndex) {
        const { dispatch } = this.props;
        const rowData = this.getRowData(rowIndex)
        dispatch({ type: tagConstants.OPEN_EDIT, formInitialValue: { ...rowData } })
    }

    openFormImportMember(rowIndex) {
        const { dispatch } = this.props;
        dispatch(change('TAG_FORM_IMPORT', 'fileImport', undefined))
        const rowData = this.getRowData(rowIndex)
        dispatch({
            type: tagConstants.OPEN_TAG_FORM_IMPORT, formImportInitialValue: {
                tagId: rowData._id
            }
        })
    }

    componentDidUpdate() {
        const { tableReload, tableReset, dispatch } = this.props;
        if (tableReload || tableReset) {
            this.getData();
            dispatch({ type: tagConstants.TABLE_RELOAD_SUCCESS })
        }
    }

    render() {
        const { formInitialValue, tableDatas, showLoader, tableKey, formImportInitialValue } = this.props;
        return (
            <div id="TableTagList">
                <CustomSweetAlert />
                <SWImportResult isOpen={true} />
                <FormTag
                    readOnly={!plugins.isHasPermission(moduleName, 'update')}
                    initialValues={formInitialValue} />
                <FormTagImportMember
                    initialValues={formImportInitialValue} />
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={tableKey}
                        title={"TAG LIST"}
                        data={tableDatas.tags}
                        columns={this.tableColumn()}
                        options={this.tableOptions()}
                    />
                    {showLoader && <TableLoaderSpinner />}
                </MuiThemeProvider>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { formInitialValue, tableDatas, tableReload, showLoader, tableKey, tableReset, formImportInitialValue } = state.tag;
    // const { permission, superAdmin } = state.authentication;
    return {
        formInitialValue, tableDatas, tableReload, showLoader, tableKey, tableReset, formImportInitialValue
    };
}

export default connect(mapStateToProps)(withStyles(pageStyle)(TableTagList));

